import { FilterType } from 'components/Shared/Table'
import {
  FERRY_SERVICE_ADDITIONAL_DATA_READ,
  FERRY_SERVICE_CONTRACTOR_READ,
  FERRY_SERVICE_DATA_READ
} from 'context/auth'

export const createColumns = (hasAnyPrivileges) => {
  const ferryServiceContractorColumns = hasAnyPrivileges([FERRY_SERVICE_CONTRACTOR_READ]) ?
    [
      {
        id: 'contractor',
        label: 'ferryServices.table.columns.contractor',
        path: 'contractorId',
        filterType: FilterType.Contractor,
        filterName: 'contractorIds'
      }
    ] : []

  const ferryServiceDataColumns = hasAnyPrivileges([FERRY_SERVICE_DATA_READ]) ?
    [
      {
        id: 'startLocationText',
        label: 'ferryServices.table.columns.startLocation.label',
        path: 'startLocation.text',
        filterType: FilterType.Text,
        sortable: true
      },
      {
        id: 'endLocationText',
        label: 'ferryServices.table.columns.endLocation.label',
        path: 'endLocation.text',
        filterType: FilterType.Text,
        sortable: true
      },
      {
        id: 'type',
        label: 'ferryServices.table.columns.type.label',
        path: 'type',
        filterType: FilterType.Text,
        sortable: true
      },
      {
        id: 'price',
        label: 'ferryServices.table.columns.price.label',
        path: 'price',
        filterType: FilterType.NumberRange,
        filterNames: ['priceGe', 'priceLe'],
        filterPlaceholders: ['ferryServices.table.columns.price.filter.minPlaceholder',
          'ferryServices.table.columns.price.filter.maxPlaceholder'],
        sortable: true
      },
      {
        id: 'currencyCode',
        label: 'ferryServices.table.columns.currencyCode.label',
        path: 'currencyCode',
        filterType: FilterType.Text,
        sortable: true
      },
      {
        id: 'bunkerAdjustmentFactor',
        label: 'ferryServices.table.columns.bunkerAdjustmentFactor.label',
        path: 'bunkerAdjustmentFactor',
        filterType: FilterType.NumberRange,
        filterNames: ['bunkerAdjustmentFactorGe', 'bunkerAdjustmentFactorLe'],
        filterPlaceholders: ['ferryServices.table.columns.bunkerAdjustmentFactor.filter.minPlaceholder',
          'ferryServices.table.columns.bunkerAdjustmentFactor.filter.maxPlaceholder'],
        sortable: true
      }
    ] : []

  const ferryServiceAdditionalDataColumns = hasAnyPrivileges([FERRY_SERVICE_ADDITIONAL_DATA_READ]) ?
    [
      {
        id: 'additionalInfo',
        label: 'ferryServices.table.columns.additionalInfo.label',
        path: 'additionalInfo',
        filterType: FilterType.None
      }
    ] : []

  return [
    ...ferryServiceContractorColumns,
    ...ferryServiceDataColumns,
    ...ferryServiceAdditionalDataColumns
  ]
}
